import { useAuthState } from "react-firebase-hooks/auth";
import React from "react";
import HeaderNav from "../components/HeaderNav";
import "./Dashboard.css";
import { auth } from "../firebase";

const Dashboard = () => {
  const [user, loading, error] = useAuthState(auth);
  return (
    <div className="dashboard">
      <HeaderNav />
      <div className="page__container">
        <h1>Welcome{user.displayName ?? "!"}</h1>
        <p>Dashboard under construction... coming soon.</p>
      </div>
    </div>
  );
};

export default Dashboard;
